import getIdReduxUtil from 'modules/redux/utils/get-id'
import { toSlugStringUtil } from 'packages/src'
import getNameReduxUtil from 'modules/redux/utils/get-name'

export default function getPathnameWorkoutUtil (instance) {
  const name = getNameReduxUtil(instance)
  return `/workouts/${getIdReduxUtil(instance)}/${toSlugStringUtil(name)}`
}
